module.exports = __webpack_public_path__ + "static/media/Team 21 Birthco - Alvina Hasty.98338aad.png";